<template>
  <div class="sidebar-logo-container" :class="{'collapse':collapse}">
    <transition name="sidebarLogoFade">
      <div v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
        <img v-if="config.smalllogoUrl" :src="config.smalllogoUrl" class="sidebar-logo">
        <h1 v-else class="sidebar-title">{{ config.logoText }} </h1>
      </div>
      <div v-else key="expand" class="sidebar-logo-link" to="/">
        <img v-if="config.logoUrl" :src="config.logoUrl" class="sidebar-logo">
        <h1 class="sidebar-title">{{ config.logoText }} </h1>
      </div>
    </transition>
  </div>
</template>

<script>
import { getInitConfig } from '@/config/config';
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      logo: '',
      config: {}
    }
  },
  created () {
    this.config = getInitConfig()
  }
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #fff;
  // background: rgba(255, 255, 255, 0.5);
  box-shadow: 0px 8px 24px 0px rgba(132, 157, 213, 0.2);
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;

    & .sidebar-logo {
      width: 145px;
      height: 36px;
      vertical-align: middle;
      margin-right: 12px;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #666;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      width: 40px;
      height: 40px;
      margin-right: 0px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/Logo.vue